export const BUCKET_WIDTH_DEFAULT = 'P1D';
